export default process?.env?.VUE_APP_REPORT_URL || ''

// export default 'https://staging.backend.sosplantao.com'
